<template>
  <div>
    <v-container>

      <v-row v-if="group2 == '0'">
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <emp-lookup
            :class-padding="classPadding"
            v-model="selectedEmp"
            label="Employee Code"
            title="Employee"
            :code-value="true"
            :off-remarks="true"
          ></emp-lookup>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="8" :class="classPadding">
          <v-text-field label="Name" :value="selectedEmp.desc" :class="classPadding"></v-text-field>
        </v-col>
       
      </v-row>

      <v-expansion-panels multiple v-model="panel" v-if="group2 == '1'">
        <v-expansion-panel>
          <v-expansion-panel-header>Effectivity Date</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
                <custom-datepicker
                  :class-padding="classPadding"
                  label="Date From"
                  v-model="dateFrom"
                ></custom-datepicker>
              </v-col>
              <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
                <custom-datepicker :class-padding="classPadding" label="Date To" v-model="dateTo"></custom-datepicker>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Emloyee List</v-expansion-panel-header>
          <v-expansion-panel-content>
            <employee-selection :show-dense="false" :show-select="true"></employee-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Payroll Location</v-expansion-panel-header>
          <v-expansion-panel-content>
            <pay-loc-selection
              :show-dense="false"
              :headers="payLocHeaders"
              :show-select="true"
              v-model="payLoc"
              :by-user="true"
            ></pay-loc-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Department</v-expansion-panel-header>
          <v-expansion-panel-content>
            <department-selection :show-dense="false" :show-select="true" v-model="department"></department-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Division</v-expansion-panel-header>
          <v-expansion-panel-content>
            <division-selection :show-dense="false" :show-select="true" v-model="division"></division-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Branch</v-expansion-panel-header>
          <v-expansion-panel-content>
            <branch-selection :show-dense="false" :show-select="true" v-model="branch"></branch-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Section</v-expansion-panel-header>
          <v-expansion-panel-content>
            <section-selection :show-dense="false" :show-select="true" v-model="section"></section-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Status</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-radio-group row v-model="group" :class="classPadding">
              <v-radio label="All" value="2"></v-radio>
              <v-radio label="Active" value="1"></v-radio>
              <v-radio label="Inactive" value="0"></v-radio>
            </v-radio-group>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-row>
        <v-col>
          <span>Report Template</span>
          <v-radio-group row v-model="group2" :class="classPadding">
            <v-radio label="Per Employee" value="0"></v-radio>
            <v-radio label="Employee List" value="1"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <v-row v-if="group2 =='0'">
         <v-col cols="12" xs="12" sm="12" md="12">
          <span>Personnel Movements</span>
          <v-data-table :items="items" :headers="empHeaders" v-if="items.length > 0"></v-data-table>
        </v-col>
      </v-row>

      <v-row>
        <v-col xs="12" sm="12" md="12">
          <v-btn outlined @click.stop="exportReport" :loading="loading" :class="classPadding">Export</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import moment from "moment";
import EventBus from "../../../events/eventBus";
const CustomDatepicker = () => import("../../../components/CustomDatepicker");
const PayLocSelection = () =>
  import("../../setup/general/payroll-location/NewSelection");
const DepartmentSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/department/NewSelection"
  );

const DivisionSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/division/NewSelection"
  );
const BranchSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/branch/NewSelection"
  );

const SectionSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/section/NewSelection"
  );
const EmployeeSelection = () =>
  import("../../maintenance/employee-masterfile/personal-info/Selection");
const EmpLookup = () =>
  import("../../maintenance/employee-masterfile/personal-info/Lookup");
const API_ENDPOINT = "/api/reports";
export default {
  data: () => ({
    title: "Purge Employee Masterfile",
    classPadding: "my-0 py-0",
    dateFrom: null,
    dateTo: null,
    payLocHeaders: [
      {
        text: "Loc Id",
        align: "left",
        //sortable: false,
        value: "locId"
      },
      {
        text: "Location Name",
        align: "left",
        //sortable: false,
        value: "locName"
      }
    ],
    payLoc: [],
    department: [],
    division: [],
    branch: [],
    section: [],
    isSearching: false,
    employees: [],
    headers: [
      {
        text: "Code",
        value: "empCode",
        sortable: false
      },
      {
        text: "Last Name",
        value: "lName",
        sortable: false
      },
      {
        text: "First Name",
        value: "fName",
        sortable: false
      },
      {
        text: "Middle Name",
        value: "mName",
        sortable: false
      }
    ],
    loading: false,
    group: "2",
    group2: "0",
    panel: [7],
    selectedEmployees: [],
    selectedEmp: {},
    items: [],
    empHeaders: [
      {
        text: "Transaction #",
        value: "transactionNo",
        sortable: false
      },
      {
        text: "Move Type",
        value: "moveTypeDesc",
        sortable: false
      },
      {
        text: "Status",
        value: "status",
        sortable: false
      },
      {
        text: "Effectivity",
        value: "effectDate",
        sortable: false
      },
      {
        text: "Pay Location",
        value: "locNameTo",
        sortable: false
      },
      {
        text: "Project",
        value: "projectDescTo",
        sortable: false
      },
      {
        text: "Department",
        value: "depDescTo",
        sortable: false
      },
      {
        text: "Division",
        value: "divDescTo",
        sortable: false
      },
      {
        text: "Branch",
        value: "braDescTo",
        sortable: false
      },
      {
        text: "Section",
        value: "secDescTo",
        sortable: false
      },
      {
        text: "Position",
        value: "desDescTo",
        sortable: false
      },
      {
        text: "Unit",
        value: "unitDescTo",
        sortable: false
      },
      {
        text: "Area",
        value: "areaDescTo",
        sortable: false
      },
      {
        text: "Location",
        value: "locationDescTo",
        sortable: false
      },
      {
        text: "Group",
        value: "grpDescTo",
        sortable: false
      },
      {
        text: "Line",
        value: "subDescTo",
        sortable: false
      },
      {
        text: "Grade",
        value: "grdDescTo",
        sortable: false
      },
      {
        text: "Emp Status",
        value: "empStatDescTo",
        sortable: false
      },
      {
        text: "Tax",
        value: "taxDescTo",
        sortable: false
      },
      {
        text: "From",
        value: "from",
        sortable: false
      },
      {
        text: "To",
        value: "to",
        sortable: false
      }
    ]
  }),
  components: {
    CustomDatepicker,
    PayLocSelection,
    DepartmentSelection,
    DivisionSelection,
    BranchSelection,
    SectionSelection,
    EmployeeSelection,
    EmpLookup
  },
  computed: {
    grp() {
      return this.payLoc.join(", ");
    },
    dep() {
      return this.department.join(", ");
    },
    div() {
      return this.division.join(", ");
    },
    bra() {
      return this.branch.join(", ");
    },
    sec() {
      return this.section.join(", ");
    },
    empCodes() {
      return this.selectedEmployees.join(", ");
    }
  },
  methods: {
    reset() {
      this.dateFrom = null;
      this.dateTo = null;
      this.payLoc = [];
      this.department = [];
      this.division = [];
      this.branch = [];
      this.section = [];
    },
    exportReport() {
      this.loading = true;
      var param = {
        Grp: this.grp,
        Dep: this.dep,
        Bra: this.bra,
        Div: this.div,
        Sec: this.sec,
        Stat: this.group,
        DateFrom: moment(this.dateFrom).format("MM/DD/YYYY"),
        DateTo: moment(this.dateTo).format("MM/DD/YYYY"),
        EmpCodes: this.empCodes,
        ReportTemplate: this.group2,
        EmpCode: this.selectedEmp.code
      };
      let url
      if(this.group2 == "0"){
        url =`${API_ENDPOINT}/personnel-emp-record`;
      }else{
        url =`${API_ENDPOINT}/personnel-emp-record/export`;
      }

      this.$axios
        .post(url, param)
        .then(({ data }) => {
           var subPath = process.env.VUE_APP_PATH;
            if(this.group2 == "0") {
              window.open(
              `${subPath.slice(0, -1)}/report-viewer?reportCode=${
                data.reportCode
              }&dbName=${data.dbName}&key=${data.key}&companyKey=${
                data.companyKey
              }&reportUrl=${data.url}&client=${data.client}&logoAlign=${
                data.logoAlign
              }&logoWidth=${data.logoWidth}&rpt=${data.rpt}`
            );
            }else {
              var nameOfTheCsv = "ListOfEmployeesPersonalEmploymentRecord.xlsx";
              this.$axios
                .get(`${url}/${data}`, {responseType: 'blob'})
                .then(response => {
                    const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', nameOfTheCsv);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }).catch(err => console.log(err));
            }
            
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getEmpRecord(empCode) {
       this.$axios
        .get(`${API_ENDPOINT}/personnel-emp-record/${empCode}`)
        .then(({ data }) => {
            this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          //this.loading = false;
        });
    }
  },
  mounted() {
    EventBus.$on("SELECTED_EMPLOYEE", payload => {
      var empCodes = payload.map(item => {
        return item.empCode;
      });
      this.selectedEmployees = empCodes;
    });
  },
  watch: {
    selectedEmp({code}) {
      this.getEmpRecord(code);
    }
  }
};
</script>